<template>
  <div>
    <b-alert
    :show="dismissCountDown"
    dismissible
    fade
    variant="primary"
    @dismissed="dismissCountDown=0"
    @dismiss-count-down="countDownChanged"
    >
      {{allertMessage}}
  </b-alert>
  <div class="container">
    <h1 class="text-center mb-1 sm">
      <base-button v-on:click="goBack" size='md' class="mt-1 back-button" type="primary">Back</base-button>
      {{customFormLabel}}</h1>
    <div class="card card-profile shadow mb-3">
        <div class="card-body">
          <vue-form-generator :schema="schema" :model="model" :options="formOptions" ref="CustomForm"></vue-form-generator>
          <div class="text-center">
            <base-button :disabled="disableButton" v-on:click="submitCustomForm" size='md' type="primary">Submit</base-button>
          </div>
        </div>
    </div>
  </div>
  </div>
</template>

<script>
import customFormsMixin from './../mixins/customFormsMixin'
import alertMixin from './../mixins/alertMixin'
import timestampMixin from './../mixins/timestampMixin'
import errorStatusMixin from './../mixins/errorStatusMixin'
export default {
  data () {
    return {
      disableButton: false,
      isValidForm: true,
      customFormLabel: '',
      schema: {
        fields: []
      },
      model: {},
      formOptions: {
        validateAfterChanged: true,
        validateAsync: true
      }
    }
  },
  computed: {
    currentCustomForm () {
      return this.$store.state.currentCustomForm
    }
  },
  mounted () {
    this.checkCustomFormIsAvaible()
    this.setSchemaCustomForm()
    this.setCustomFormModel()
    this.getCurrentFormLabel()
  },
  methods: {
    getCurrentFormLabel () {
      let forms = this.$store.state.customForms
      return forms.forEach((item) => {
        if (item.formName === this.currentCustomForm) this.customFormLabel = item.formLabel
      })
    },
    checkCustomFormIsAvaible () {
      if (!this.currentCustomForm) this.$router.push({ path: 'forms' })
    },
    setSchemaCustomForm () {
      this.schema.fields = this.getCustomFormfields(this.currentCustomForm)
    },
    setCustomFormModel () {
      this.model = this.getCustomFormModel(this.getCustomFormfields(this.currentCustomForm))
    },
    async submitCustomForm () {
      let errors = await this.$refs.CustomForm.validate()
      if (errors.length > 0) return
      this.disableButton = true
      let data = {}
      // Adding to dataObj array with all values exept images
      data.records = this.getImagesOrTextData(this.model, false)
      // Add images array from custom form
      data.images = this.getImagesOrTextData(this.model, true)
      let token = this.$store.state.user.token
      let formName = this.currentCustomForm
      let time = this.getCurrentTime()
      let dataObj = Object.assign(data, { token, formName, time })
      this.$store.dispatch('sendCustomFormsData', dataObj).then(response => {
        this.disableButton = false
        if (response) {
          this.resetForm()
          this.showAlert(3, 'Data has been uploaded to server successfully')
        }
      }).catch(err => {
        this.disableButton = false
        if (!this.errorStatusAvaible(err) && this.isOnline) return this.showAlert(4, 'The request timeout exceeded. The data has been saved and uploaded later')
        if (this.isOnline) return this.showAlert(3, err.response.data.result.message)
        this.resetForm()
        this.showAlert(3, 'You are offline now. The data has been save and upload when online')
      })
    },
    // If we want get images second param need to be true
    // otherwise false
    getImagesOrTextData (data, bool) {
      let schemaFields = this.schema.fields
      let dataArr = []
      schemaFields.forEach((item) => {
        if (!data[item.model]) return
        if ((bool && item.type === 'image') || (!bool && item.type !== 'image')) {
          let dataObj = {}
          dataObj[item.model] = data[item.model]
          dataArr.push(dataObj)
        }
      })
      return dataArr
    },
    resetForm () {
      this.model = {}
    },
    goBack () {
      this.$router.push('/forms')
    }
  },
  beforeDestroy () {
    this.$store.commit('reloadCustomForm')
  },
  mixins: [customFormsMixin, alertMixin, timestampMixin, errorStatusMixin]
}
</script>
<style scoped>
  .form-control.is-invalid {
    background-image: none;
  }
  .pointer {
    cursor: pointer;
  }
</style>
